export default __webpack_public_path__ + "static/media/safe_mobile.b7803f58.svg";